import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig } from "@/utils/constants/configContants";
import { getCurrentOrganization } from "@/utils/functions/OrganizationFunctions";

export const fetchAuditLogs = async (pageNo: number, dataLength: number, sorting: any, searchItem: string, callback: any, errorCallback: any) => {
    const current_org: string = getCurrentOrganization().organization

    axios.get(`${BASEDOMAIN}/audit-log/${current_org}?page=${pageNo}&limit=${dataLength}&sort=${JSON.stringify(sorting)}${searchItem ? `&search=${searchItem}` : ''}`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e);
            console.log(e);
        });
};